<script setup>
import { DocumentTextIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import DisplayContentAction from "@js/components/actions/DisplayContentAction.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { row } = defineProps({
  row: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div class="flex h-full flex-row items-center gap-2 p-4">
    <DisplayContentAction
      v-if="row.original.budgetNotes"
      :title="t('title.budgetNotes')"
      :content="row.original.budgetNotes"
    >
      <template #button="{ setIsOpen }">
        <ActionButton
          size="small"
          class="size-8"
          :title="t('button.seeBudgetNotes')"
          type="primary"
          :callback="() => setIsOpen(true)"
          :icon="DocumentTextIcon"
        />
      </template>
    </DisplayContentAction>
  </div>
</template>
